import React from 'react';

class TextInput extends React.Component{

    render(){
      const { 
        input_type, 
        input_name, 
        input_label, 
        input_value, 
        input_placeholder, 
        input_onChange,
        input_invalid_feedback,
        input_helper,
        input_is_required,
        input_parent,
        input_rows
      } = this.props;

      return(
        
        <div className="form-group">
          <label className="form-control-label">{ this.props.input_label }</label>
             <input 
              className="form-control" 
              type={ input_type } 
              name={ input_name } 
              value={ input_value } 
              onChange={ input_onChange } 
              placeholder={ input_placeholder } 
              required={ input_is_required }
              data-parent={ input_parent }
            />
          {input_helper && <small className="help-block">{input_helper}</small>}
          <div className="invalid-feedback">{ input_invalid_feedback }</div>
        </div>
      );
    }
} 

export {TextInput};


// WEBPACK FOOTER //
// ./src/components/TextInput.js